exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal.fade {\n    background: rgba(0, 0, 0, 0.5);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/import-crating/import-crating.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/import-crating/import-crating.component.css
// module chunks = 3